export default __webpack_public_path__ + "static/position-right-733b0872de9b8cac8dae2e32c73b6373.png";